import { render, staticRenderFns } from "./FootSlides.vue?vue&type=template&id=532a28de&scoped=true&lang=pug"
import script from "./FootSlides.vue?vue&type=script&lang=js"
export * from "./FootSlides.vue?vue&type=script&lang=js"
import style0 from "./FootSlides.vue?vue&type=style&index=0&id=532a28de&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a28de",
  null
  
)

export default component.exports